import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { loginSchema } from "./schemas/authenticationSchema.js";

import Button from "../../components/Button.js";
import Input from "../../components/Input.js";

import { signIn } from "./api/authRequest.js";

const SignIn = () => {
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(loginSchema),
    });

    const onSubmit = async (data) => {
        setError("");
        try {
            const res = await signIn(data);
            localStorage.setItem("userId", res.data.userId);
            navigate("/questions");
        } catch (err) {
            console.error("Error logging in:", err);
            if (err.response?.status === 401) {
                setError("Invalid email or password.");
            } else {
                setError("Something went wrong. Please try again.");
            }
        }
    };

    return (
        <>
            <div className="custom-container w-4/5 md:w-2/3 lg:w-1/3 mx-auto">
                <h4 className="text-lg md:text-2xl text-center mx-auto mb-6">
                    Welcome to the Injury Impact Severity Score (IISS) triage
                    tool which provides on-field clinical decision support
                </h4>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input
                        label="Email"
                        name="email"
                        register={register}
                        errors={errors}
                        placeholder="Enter your email"
                    />
                    <Input
                        label="Password"
                        name="password"
                        type="password"
                        register={register}
                        errors={errors}
                        placeholder="Enter your password"
                    />
                    <p
                        className=" text-teal-600 font-semibold cursor-pointer"
                        onClick={() => navigate("/forgot-password")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/forgot-password");
                            }
                        }}
                    >
                        Forgot your password? Click HERE
                    </p>
                    {error && <p className=" text-red-600">{error}</p>}
                    <Button type="submit" isLoading={isSubmitting}>
                        Login
                    </Button>
                </form>
                <hr className="mt-6 border border-gray-200 w-full p-0 mx-auto" />
                <div className="mt-4 px-2 flex justify-between items-center">
                    <p>Don't have an account?</p>
                    <h6
                        className="text-teal-600 cursor-pointer"
                        onClick={() => navigate("/register")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/register");
                            }
                        }}
                    >
                        Register
                    </h6>
                </div>
            </div>
        </>
    );
};

export default SignIn;
